import React from 'react';
import { connect } from 'react-redux';
import { useAuth0, withAuth0 } from '@auth0/auth0-react';
import {
	setAdminSSOProfile,
	setAuth0Token,
	setCurrentClientID,
	thunkCreateSaaSAdmin,
} from '../../redux/actions';
import Loader from 'components/Loader';
import AdminPermissionsCheck from './AdminPermissionsCheck';

const WithAuth = props => {
	const { admins, children, auth0Token, adminSSOProfile, permissive } = props;
	const { loginWithRedirect } = useAuth0();

	if (!adminSSOProfile) {
		loginWithRedirect();
		return;
	}

	if (!auth0Token || !adminSSOProfile) return <Loader />;

	return (
		<AdminPermissionsCheck
			admins={admins}
			adminSSOProfile={adminSSOProfile}
			permissive={permissive}
		>
			{children}
		</AdminPermissionsCheck>
	);
};

const msp = state => ({
	adminSSOProfile: state.auth.adminSSOProfile,
	auth0Token: state.auth.auth0Token,
	admins: state.admins,
});

const mdp = dispatch => ({
	setAdminSSOProfile: profile => dispatch(setAdminSSOProfile(profile)),
	setAuth0Token: auth0Token => dispatch(setAuth0Token(auth0Token)),
	setCurrentClientID: clientID => dispatch(setCurrentClientID(clientID)),
	createSaaSAdmin: email => dispatch(thunkCreateSaaSAdmin(email)),
});

export default withAuth0(connect(msp, mdp)(WithAuth));
